import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const NAV_LINKS = [
  { id: "inicio", label: "Inicio" },
  { id: "servicios", label: "Servicios" },
  { id: "equipo", label: "Quiénes somos" },
  { id: "como-trabajamos", label: "Cómo trabajamos" },
  { id: "colaboraciones", label: "Colaboraciones" },
  { id: "honorarios", label: "Honorarios" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm"
          : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => handleClick("inicio")}
            className="cursor-pointer"
            data-testid="nav-logo-btn"
            aria-label="Ir al inicio"
          >
            <Logo />
          </button>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                onClick={() => handleClick(link.id)}
                data-testid={`nav-link-${link.id}`}
                className="px-3 py-2 text-sm text-ink-muted hover:text-navy transition-colors font-medium"
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:block">
            <button
              onClick={() => handleClick("contacto")}
              data-testid="nav-cta-contact"
              className="bg-navy text-white hover:bg-navy-700 px-5 py-2.5 rounded-md transition-all font-medium text-sm"
            >
              Contactar
            </button>
          </div>

          <button
            className="lg:hidden p-2 text-navy"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t border-slate-100" data-testid="mobile-menu">
            <nav className="flex flex-col gap-1">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.id}
                  onClick={() => handleClick(link.id)}
                  data-testid={`mobile-nav-link-${link.id}`}
                  className="text-left px-3 py-3 text-sm text-ink-muted hover:text-navy hover:bg-slate-50 rounded-md transition-colors font-medium"
                >
                  {link.label}
                </button>
              ))}
              <button
                onClick={() => handleClick("contacto")}
                data-testid="mobile-nav-cta"
                className="mt-3 bg-navy text-white hover:bg-navy-700 px-5 py-3 rounded-md transition-all font-medium text-sm"
              >
                Contactar
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
